<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData, storeBooking, storeSelectedIcon } from '../../library/scripts/Store.svelte'
	import {
		get_element_tags,
		get_initial_values,
		string_to_fontsize,
		get_blocks,
		fontsize_to_string,
	} from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let iconTxtContAlignL = globals.colorDark
	let iconTxtContAlignC = globals.colorDark
	let iconTxtContAlignR = globals.colorDark
	let iconValignT = globals.colorDark
	let iconValignC = globals.colorDark
	let iconValignB = globals.colorDark
	let iconTitleWeight = globals.colorDark
	let iconTitleStyle = globals.colorDark
	let iconTitleDeco = globals.colorDark
	let iconTitleStroke = globals.colorDark
	let iconLabelWeight = globals.colorDark
	let iconLabelStyle = globals.colorDark
	let iconLabelDeco = globals.colorDark
	let mainTool = globals.mainTool
	let mainToolHover = globals.mainToolHover
	let subTool = globals.subTool
	let subToolHover = globals.subToolHover
	const iconHover = globals.colorError
	const fontSize = globals.fontSize
	const fontFamily = globals.fontFamily
	const fontSizeSmall = globals.fontSizeSmall

	let generalTool1
	let generalTool2
	let generalTool3
	let showTool0
	let showTool1
	let showTool2
	let showTool3
	let showTool4
	let showTool5
	let showTool6
	let showTool7
	let showTool8
	let showTool9
	let showTool10
	let showTool11
	let showTool12
	let showTool13
	let showTool14
	let showTool15
	let showTool16

	let elementID
	let config
	let blocks
	let blockID, columnID, elementTag

	//show border tools
	let iconSelected = false

	//icon selected
	let selectedIcon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false

	//selection borders
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false
	let icon10 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor

	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor
	let icon10Color = iconColor

	//css selections
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleBgOpac,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		inputFontColor,
		inputFontFamily,
		inputFontSize,
		inputBorderWidth,
		inputBorderColor,
		inputBg,
		inputFocus,
		inputShadowX,
		inputShadowY,
		inputShadowBlur,
		inputShadowColor,
		labelFontSize,
		lableFontColor,
		lableFontFF,
		labelMarginTop,
		labelMarginBottom,
		confFF,
		confColor,
		backgroundColor,
		bgOpac,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		marginTop,
		marginBottom,
		padding,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		buttonBg,
		buttonBgHover,
		buttonFontColor,
		buttonFontHover,
		buttonFontFamily,
		buttonFontSize,
		buttonBorderWidth,
		buttonBorderColor,
		buttonBorderRadius,
		pickerColorSelected,
		pickerColorDisabled,
		pickerColor,
		pickerColorBorder,
		pickerColorHover,
		respColor,
		titleBarSC,
		titleBarY,
		titleBarB,
		selectionBG,
		selectionOpac,
		labelWeight,
		labelStyle,
		labelDeco,
		selectionBLC,
		selectionBLW,
		selectionBTC,
		selectionBTW,
		selectionBRC,
		selectionBRW,
		selectionBBC,
		selectionBBW,
		selectionSC,
		selectionSX,
		selectionSY,
		selectionSB

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	let idColor1 = '101'
	let idColor2 = '102'
	let idColor3 = '103'
	let idColor4 = '104'
	let idColor5 = '105'
	let idColor6 = '106'
	let idColor7 = '107'
	let idColor8 = '108'
	let idColor9 = '109'
	let idColor10 = '110'
	let idColor11 = '111'
	let idColor12 = '112'
	let idColor13 = '113'
	let idColor14 = '114'
	let idColor15 = '115'
	let idColor16 = '116'
	let idColor17 = '117'
	let idColor18 = '118'
	let idColor19 = '119'
	let idColor20 = '120'
	let idColor21 = '121'
	let idColor22 = '122'
	let idColor23 = '123'
	let idMarginTop = '3'
	let idMarginBottom = '4'
	let idPadding = '5'
	let idShadowX = '6'
	let idShadowY = '7'
	let idShadowBlur = '8'
	let idTitleHeight = '9'
	let idTitleMT = '10'
	let idTTXTShadowX = '11'
	let idTTXTShadowY = '12'
	let idTTXTShadowBlur = '13'
	let idInputSX = '14'
	let idInputSY = '15'
	let idInputSB = '16'
	let idRoomsBRT = '17'
	let idRoomsBRB = '18'
	let idRoomsBW = '20'
	let idTitleContainerY = '21'
	let idTitleContainerB = '22'
	let idSelectionSX = '23'
	let idSelectionSY = '24'
	let idSelectionSB = '25'
	let idBorderWidth = '26'
	let idSectionBW = '27'
	let idBTradius = '28'
	let idBBradius = '29'
	let idTitleMB = '30'
	let idTitleP = '31'
	let idRoomsIMGSX = '32'
	let idRoomsIMGSY = '33'
	let idRoomsIMGSB = '34'

	//change layout order
	let shaderChangeOrder = false

	//the values to send to sizeSelectors
	let selectedBorderWidth

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	let selectedStoreIcon
	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false
	$: if (!icon6 && !icon7 && !icon8 && !icon9 && !icon10) iconSelected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = borderLeftWidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = borderTopWidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = borderRightWidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = borderBottomWidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = borderLeftWidth

	$: if (selectedStoreIcon === 'icon6') selectedBorderWidth = selectionBLW
	$: if (selectedStoreIcon === 'icon7') selectedBorderWidth = selectionBTW
	$: if (selectedStoreIcon === 'icon8') selectedBorderWidth = selectionBRW
	$: if (selectedStoreIcon === 'icon9') selectedBorderWidth = selectionBBW
	$: if (selectedStoreIcon === 'icon10') selectedBorderWidth = selectionBLW

	const set_icon_color = (cmd, c) => {
		if (cmd === 'block') {
			if (c === 'left') icon1Color = iconHover
			if (c === 'top') icon2Color = iconHover
			if (c === 'right') icon3Color = iconHover
			if (c === 'bottom') icon4Color = iconHover
			if (c === 'all') {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}
			if (c === 'none') {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
		}

		if (cmd === 'selection') {
			if (c === 'left') icon6Color = iconHover
			if (c === 'top') icon7Color = iconHover
			if (c === 'right') icon8Color = iconHover
			if (c === 'bottom') icon9Color = iconHover
			if (c === 'all') {
				icon6Color = iconHover
				icon7Color = iconHover
				icon8Color = iconHover
				icon9Color = iconHover
				icon10Color = iconHover
			}
			if (c === 'none') {
				icon6Color = iconColor
				icon7Color = iconColor
				icon8Color = iconColor
				icon9Color = iconColor
				icon10Color = iconColor
			}
		}
	}

	//set the initial css values from config.json
	$: if (elementID === 'booking') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		blockTitleWidth = values[0]
		blockTitleHeight = values[1]
		blockTitleAlignHorizontal = set_icon_title_align_initial_value(values[2])
		blockTitleAlignVertical = set_icon_title_valign_initial_value(values[3])
		blockTitleFontFamily = values[4]
		blockTitleFontColor = values[5]
		blockTitleFontSize = fontsize_to_string(values[6])
		blockTitleFontWeight = values[7]
		blockTitleFontStyle = values[8]
		blockTitleFontDeco = values[9]
		set_fontstyle_initial_value('title', blockTitleFontWeight, blockTitleFontStyle, blockTitleFontDeco)
		blockTitleBackgroundColor = values[10]
		blockTitleMarginTop = values[11]
		blockTitleMarginBottom = values[12]
		blockTitlePadding = values[13]
		blockTitleShadowColor = values[14]
		blockTitleShadowOffsetX = values[15]
		blockTitleShadowOffsetY = values[16]
		blockTitleShadowBlur = values[17]
		inputFontColor = values[18]
		inputFontFamily = values[19]
		inputFontSize = values[20]
		inputBorderWidth = values[21]
		inputBorderColor = values[22]
		inputBg = values[23]
		inputFocus = values[24]
		inputShadowX = values[25]
		inputShadowY = values[26]
		inputShadowBlur = values[27]
		inputShadowColor = values[28]
		labelFontSize = values[29]
		lableFontColor = values[30]
		lableFontFF = values[31]
		labelMarginTop = values[32]
		labelMarginBottom = values[33]
		confFF = values[34]
		confColor = values[35]
		backgroundColor = values[36]
		backgroundImage = values[37]
		backgroundSize = values[38]
		backgroundRepeat = values[39]
		borderTopRadius = values[40]
		borderBottomRadius = values[41]
		borderLeftWidth = values[42]
		borderLeftStyle = values[43]
		borderLeftColor = values[44]
		borderTopWidth = values[45]
		borderTopStyle = values[46]
		borderTopColor = values[47]
		borderRightWidth = values[48]
		borderRightStyle = values[49]
		borderRightColor = values[50]
		borderBottomWidth = values[51]
		borderBottomStyle = values[52]
		borderBottomColor = values[53]
		marginTop = values[54]
		marginBottom = values[55]
		padding = values[56]
		blockBoxShadowX = values[57]
		blockBoxShadowY = values[58]
		blockBoxShadowBlur = values[59]
		blockBoxShadowColor = values[60]
		buttonBg = values[61]
		buttonBgHover = values[62]
		buttonFontColor = values[63]
		buttonFontHover = values[64]
		buttonFontFamily = values[65]
		buttonFontSize = values[66]
		buttonBorderWidth = values[67]
		buttonBorderColor = values[68]
		buttonBorderRadius = values[69]
		pickerColorSelected = values[70]
		pickerColorDisabled = values[71]
		pickerColor = values[72]
		pickerColorBorder = values[73]
		pickerColorHover = values[74]
		respColor = values[75]
		bgOpac = values[76]
		blockTitleBgOpac = values[77]
		titleBarSC = values[78]
		titleBarY = values[79]
		titleBarB = values[80]
		selectionBG = values[81]
		selectionOpac = values[82]
		labelWeight = values[83]
		labelStyle = values[84]
		labelDeco = values[85]
		set_fontstyle_initial_value('selection', labelWeight, labelStyle, labelDeco)
		selectionBLC = values[86]
		selectionBLW = values[87]
		selectionBTC = values[87]
		selectionBTW = values[89]
		selectionBRC = values[90]
		selectionBRW = values[91]
		selectionBBC = values[92]
		selectionBBW = values[93]
		selectionSC = values[94]
		selectionSX = values[95]
		selectionSY = values[96]
		selectionSB = values[97]

		if (borderLeftWidth > 0) {
			icon1 = true
			set_icon_color('block', 'left')
		}
		if (borderTopWidth > 0) {
			icon2 = true
			set_icon_color('block', 'top')
		}

		if (borderRightWidth > 0) {
			icon3 = true
			set_icon_color('block', 'right')
		}

		if (borderBottomWidth > 0) {
			icon4 = true
			set_icon_color('block', 'bottom')
		}

		if (borderLeftWidth > 0 && borderTopWidth > 0 && borderRightWidth > 0 && borderBottomWidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('block', 'all')
		}

		if (selectionBLW > 0) {
			icon6 = true
			set_icon_color('selection', 'left')
		}
		if (selectionBTW > 0) {
			icon7 = true
			set_icon_color('selection', 'top')
		}

		if (selectionBRW > 0) {
			icon8 = true
			set_icon_color('selection', 'right')
		}

		if (selectionBBW > 0) {
			icon9 = true
			set_icon_color('selection', 'bottom')
		}

		if (selectionBLW > 0 && selectionBTW > 0 && selectionBRW > 0 && selectionBBW > 0) {
			icon6 = true
			icon7 = true
			icon8 = true
			icon9 = true
			icon10 = true
			set_icon_color('selection', 'all')
		}
	}

	const set_icon_title_align_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconTxtContAlignL = iconHover
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconHover
				iconTxtContAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconHover
				return
			}
		}
	}

	const set_fontstyle_initial_value = (c, w, s, d) => {
		if (c === 'title') {
			if (w === 'bold') iconTitleWeight = iconHover
			if (w === 'normal') iconTitleWeight = iconColor
			if (s === 'italic') iconTitleStyle = iconHover
			if (s === 'normal') iconTitleStyle = iconColor
			if (d === 'none') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconColor
			}
			if (d === 'underline') {
				iconTitleDeco = iconHover
				iconTitleStroke = iconColor
			}
			if (d === 'line-through') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconHover
			}
		}

		if (c === 'selection') {
			if (w === 'bold') iconLabelWeight = iconHover
			if (w === 'normal') iconLabelWeight = iconColor
			if (s === 'italic') iconLabelStyle = iconHover
			if (s === 'normal') iconLabelStyle = iconColor
			if (d === 'none') iconLabelDeco = iconColor
			if (d === 'underline') iconLabelDeco = iconHover
		}
	}

	const set_icon_title_valign_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconValignT = iconHover
				iconValignC = iconColor
				iconValignB = iconColor
				return
			}
			if (v === 'center') {
				iconValignT = iconColor
				iconValignC = iconHover
				iconValignB = iconColor
				return
			}

			if (v === 'flex-end') {
				iconValignT = iconColor
				iconValignC = iconColor
				iconValignB = iconHover
				return
			}
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'blockBG') block.backgroundColor = cssTag
				if (cmd === 'blockMT') block.marginTop = cssTag
				if (cmd === 'blockMB') block.marginBottom = cssTag
				if (cmd === 'blockP') block.padding = cssTag
				// block borders
				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderLeftWidth = 0
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderTopWidth = 0
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderRightWidth = 0
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderBottomWidth = 0
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.borderLeftWidth = 0
						block.borderTopWidth = 0
						block.borderRightWidth = 0
						block.borderBottomWidth = 0
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor
						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'sBL') {
					if (icon6 && selectedIcon === 'icon6') {
						block.selectionBLC = cssTag
						block.selectionBLW = 1
						icon6Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.selectionBLW = 0
						icon6Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'sBT') {
					if (icon7 && selectedIcon === 'icon7') {
						block.selectionBTC = cssTag
						block.selectionBTW = 1
						icon7Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.selectionBTW = 0
						icon7Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'sBR') {
					if (icon8 && selectedIcon === 'icon8') {
						block.selectionBRC = cssTag
						block.selectionBRW = 1
						icon8Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.selectionBRW = 0
						icon8Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'sBB') {
					if (icon9 && selectedIcon === 'icon9') {
						block.selectionBBC = cssTag
						block.selectionBBW = 1
						icon9Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.selectionBBW = 0
						icon9Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'sBA') {
					if (icon10 && selectedIcon === 'icon10') {
						block.selectionBLC = cssTag
						block.selectionBLW = 1
						block.selectionBTC = cssTag
						block.selectionBTW = 1
						block.selectionBRC = cssTag
						block.selectionBRW = 1
						block.selectionBBC = cssTag
						block.selectionBBW = 1
						icon10Color = iconHover
						icon6Color = iconHover
						icon7Color = iconHover
						icon8Color = iconHover
						icon9Color = iconHover
					} else {
						block.selectionBLW = 0
						block.selectionBTW = 0
						block.selectionBRW = 0
						block.selectionBBW = 0
						icon10Color = iconColor
						icon6Color = iconColor
						icon7Color = iconColor
						icon8Color = iconColor
						icon9Color = iconColor
						icon6 = false
						icon7 = false
						icon8 = false
						icon9 = false
						icon10 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftWidth = cssTag
						block.borderTopWidth = cssTag
						block.borderRightWidth = cssTag
						block.borderBottomWidth = cssTag
					}
				}

				if (cmd === 'sBWidth') {
					if (icon6 && selectedIcon === 'icon6') block.selectionBLW = cssTag
					if (icon7 && selectedIcon === 'icon7') block.selectionBTW = cssTag
					if (icon8 && selectedIcon === 'icon8') block.selectionBRW = cssTag
					if (icon9 && selectedIcon === 'icon9') block.selectionBBW = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.selectionBLW = cssTag
						block.selectionBTW = cssTag
						block.selectionBRW = cssTag
						block.selectionBBW = cssTag
					}
				}

				if (cmd === 'bColor') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'sBColor') {
					if (icon6 && selectedIcon === 'icon6') block.selectionBLC = cssTag
					if (icon7 && selectedIcon === 'icon7') block.selectionBTC = cssTag
					if (icon8 && selectedIcon === 'icon8') block.selectionBRC = cssTag
					if (icon9 && selectedIcon === 'icon9') block.selectionBBC = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.selectionBLC = cssTag
						block.selectionBTC = cssTag
						block.selectionBRC = cssTag
						block.selectionBBC = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.borderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.borderBottomRadius = cssTag
				}

				if (cmd === 'sX') block.blockBoxShadowX = cssTag
				if (cmd === 'sY') block.blockBoxShadowY = cssTag
				if (cmd === 'sB') block.blockBoxShadowBlur = cssTag
				if (cmd === 'sC') block.blockBoxShadowColor = cssTag
				if (cmd === 'titleHeight') block.blockTitleHeight = cssTag
				if (cmd === 'blockTitleMT') block.blockTitleMarginTop = cssTag
				if (cmd === 'blockTitleMB') block.blockTitleMarginBottom = cssTag
				if (cmd === 'blockTitleP') block.blockTitlePadding = cssTag
				if (cmd === 'blockTitleBG') block.blockTitleBackgroundColor = cssTag
				if (cmd === 'tsY') block.blockTitlebarY = cssTag
				if (cmd === 'tsB') block.blockTitlebarB = cssTag
				if (cmd === 'tsC') block.blockTitlebarSC = cssTag
				if (cmd == 'tfC') block.blockTitleFontColor = cssTag
				if (cmd === 'tFF') block.blockTitleFontFamily = cssTag
				if (cmd === 'tFS') block.blockTitleFontSize = cssTag
				if (cmd === 'tFW') block.blockTitleFontWeight = cssTag
				if (cmd === 'tFSTY') block.blockTitleFontStyle = cssTag
				if (cmd === 'tFD') block.blockTitleFontDeco = cssTag
				if (cmd === 'tSX') block.blockTitleShadowOffsetX = cssTag
				if (cmd === 'tSY') block.blockTitleShadowOffsetY = cssTag
				if (cmd === 'tSB') block.blockTitleShadowBlur = cssTag
				if (cmd === 'tSC') block.blockTitleShadowColor = cssTag
				if (cmd === 'tAlign') block.blockTitleAlignHorizontal = cssTag
				if (cmd === 'tValign') block.blockTitleAlignVertical = cssTag
				if (cmd === 'sBG') block.selectionBG = cssTag
				if (cmd === 'sFC') block.lableFontColor = cssTag
				if (cmd === 'sFW') block.labelWeight = cssTag
				if (cmd === 'sFS') block.labelStyle = cssTag
				if (cmd === 'sFD') block.labelDeco = cssTag
				if (cmd === 'sSC') block.selectionSC = cssTag
				if (cmd === 'sSX') block.selectionSX = cssTag
				if (cmd === 'sSY') block.selectionSY = cssTag
				if (cmd === 'sSB') block.selectionSB = cssTag

				if (cmd === 'iFC') block.inputFontColor = cssTag
				if (cmd === 'iBGC') block.inputBg = cssTag
				if (cmd === 'iFOC') block.inputFocusColor = cssTag
				if (cmd === 'iBC') block.inputBorderColor = cssTag
				if (cmd === 'iSC') block.inputShadowColor = cssTag
				if (cmd === 'iSX') block.inputShadowX = cssTag
				if (cmd === 'iSY') block.inputShadowY = cssTag
				if (cmd === 'iSB') block.inputShadowBlur = cssTag
				if (cmd === 'iFF') block.inputFontFamily = cssTag
				if (cmd === 'iLFF') block.lableFontFF = cssTag
				if (cmd === 'cFF') block.confFF = cssTag
				if (cmd === 'cFC') block.confColor = cssTag
				if (cmd === 'bFF') block.buttonFontFamily = cssTag
				if (cmd === 'bFC') block.buttonFontColor = cssTag
				if (cmd === 'bFH') block.buttonFontHover = cssTag
				if (cmd === 'bBGC') block.buttonBg = cssTag
				if (cmd === 'bHC') block.buttonBgHover = cssTag
				if (cmd === 'bBC') block.buttonBorderColor = cssTag
				if (cmd === 'pCDC') block.pickerColorSelected = cssTag
				if (cmd === 'pDDC') block.pickerColorDisabled = cssTag
				if (cmd === 'pDHC') block.pickerColorHover = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_title_height = (e) => {
		set_css_tag(e.detail.value, 'titleHeight')
	}

	const set_title_margin_top = (e) => {
		set_css_tag(e.detail.value, 'blockTitleMT')
	}

	const set_title_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'blockTitleMB')
	}

	const set_title_padding = (e) => {
		set_css_tag(e.detail.value, 'blockTitleP')
	}

	const set_title_bg_color = (e) => {
		set_css_tag(e.detail.color, 'blockTitleBG')
	}

	const set_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColor')
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'blockBG')
	}

	const set_block_title_font_family = (e) => {
		const font = e.detail.font
		set_css_tag(font, 'tFF')
	}

	const set_block_title_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'tFS')
	}

	const set_block_title_font_weight = () => {
		if (blockTitleFontWeight === 'bold') {
			iconTitleWeight = iconColor
			set_css_tag('normal', 'tFW')
		} else {
			iconTitleWeight = iconHover
			set_css_tag('bold', 'tFW')
		}
	}

	const set_block_title_font_style = () => {
		if (blockTitleFontStyle === 'none') {
			iconTitleStyle = iconHover
			set_css_tag('italic', 'tFSTY')
		} else {
			iconTitleStyle = iconColor
			set_css_tag('none', 'tFSTY')
		}
	}

	const set_block_title_font_underline = () => {
		if (blockTitleFontDeco === 'underline') {
			iconTitleDeco = iconColor
			set_css_tag('none', 'tFD')
		} else {
			iconTitleDeco = iconHover
			set_css_tag('underline', 'tFD')
		}
	}

	const set_block_title_font_strikethrough = () => {
		if (blockTitleFontDeco === 'none' || blockTitleFontDeco === 'underline') {
			iconTitleDeco = iconColor
			set_css_tag('line-through', 'tFD')
		} else {
			iconTitleDeco = iconHover
			set_css_tag('none', 'tFD')
		}
	}

	const set_title_align_left = () => {
		set_css_tag('flex-start', 'tAlign')
	}

	const set_title_align_center = () => {
		set_css_tag('center', 'tAlign')
	}

	const set_title_align_right = () => {
		set_css_tag('flex-end', 'tAlign')
	}

	const set_title_valign_top = () => {
		set_css_tag('flex-start', 'tValign')
	}

	const set_title_valign_center = () => {
		set_css_tag('center', 'tValign')
	}

	const set_title_valign_bottom = () => {
		set_css_tag('flex-end', 'tValign')
	}

	const set_column_title_radius = (e) => {
		set_css_tag(e.detail.value, 'CTBR')
	}

	const set_margin_top = (e) => {
		set_css_tag(e.detail.value, 'blockMT')
	}

	const set_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'blockMB')
	}

	const set_padding = (e) => {
		set_css_tag(e.detail.value, 'blockP')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_SC = (e) => {
		set_css_tag(e.detail.color, 'sBColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_SW = (e) => {
		set_css_tag(e.detail.value, 'sBWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sX')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_title_container_Y = (e) => {
		set_css_tag(e.detail.value, 'tsY')
	}

	const set_title_container_B = (e) => {
		set_css_tag(e.detail.value, 'tsB')
	}

	const set_title_container_SC = (e) => {
		set_css_tag(e.detail.color, 'tsC')
	}

	const set_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'tfC')
	}

	const set_title_SY = (e) => {
		set_css_tag(e.detail.value, 'tSY')
	}

	const set_title_SX = (e) => {
		set_css_tag(e.detail.value, 'tSX')
	}

	const set_title_SB = (e) => {
		set_css_tag(e.detail.value, 'tSB')
	}

	const set_title_SC = (e) => {
		set_css_tag(e.detail.color, 'tSC')
	}

	const set_selection_bg = (e) => {
		set_css_tag(e.detail.color, 'sBG')
	}

	const set_selection_LC = (e) => {
		set_css_tag(e.detail.color, 'sFC')
	}

	const set_selection_SC = (e) => {
		set_css_tag(e.detail.color, 'sSC')
	}

	const set_selection_SX = (e) => {
		set_css_tag(e.detail.value, 'sSX')
	}

	const set_selection_SY = (e) => {
		set_css_tag(e.detail.value, 'sSY')
	}

	const set_selection_SB = (e) => {
		set_css_tag(e.detail.value, 'sSB')
	}

	const set_selection_IFC = (e) => {
		set_css_tag(e.detail.color, 'iFC')
	}

	const set_selection_IBGC = (e) => {
		set_css_tag(e.detail.color, 'iBGC')
	}

	const set_selection_IFOC = (e) => {
		set_css_tag(e.detail.color, 'iFOC')
	}

	const set_selection_IBC = (e) => {
		set_css_tag(e.detail.color, 'iBC')
	}

	const set_selection_ISC = (e) => {
		set_css_tag(e.detail.color, 'iSC')
	}

	const set_selection_ISX = (e) => {
		set_css_tag(e.detail.value, 'iSX')
	}

	const set_selection_ISY = (e) => {
		set_css_tag(e.detail.value, 'iSY')
	}

	const set_selection_ISB = (e) => {
		set_css_tag(e.detail.value, 'iSB')
	}

	const set_selection_IFF = (e) => {
		set_css_tag(e.detail.font, 'iFF')
	}

	const set_selection_ILFF = (e) => {
		set_css_tag(e.detail.font, 'iLFF')
	}

	const set_selection_BFF = (e) => {
		set_css_tag(e.detail.font, 'bFF')
	}

	const set_selection_BFC = (e) => {
		set_css_tag(e.detail.color, 'bFC')
	}

	const set_selection_BFH = (e) => {
		set_css_tag(e.detail.color, 'bFH')
	}

	const set_selection_BBGC = (e) => {
		set_css_tag(e.detail.color, 'bBGC')
	}

	const set_selection_BHC = (e) => {
		set_css_tag(e.detail.color, 'bHC')
	}

	const set_selection_BBC = (e) => {
		set_css_tag(e.detail.color, 'bBC')
	}

	const set_selection_PCDC = (e) => {
		set_css_tag(e.detail.color, 'pCDC')
	}

	const set_selection_PDDC = (e) => {
		set_css_tag(e.detail.color, 'pDDC')
	}

	const set_selection_PDHC = (e) => {
		set_css_tag(e.detail.color, 'pDHC')
	}

	const set_label_font_weight = () => {
		if (labelWeight === 'bold') {
			iconLabelWeight = iconColor
			set_css_tag('normal', 'sFW')
		} else {
			iconLabelWeight = iconHover
			set_css_tag('bold', 'sFW')
		}
	}

	const set_label_font_style = () => {
		if (labelStyle === 'italic') {
			iconLabelStyle = iconColor
			set_css_tag('none', 'sFS')
		} else {
			iconLabelStyle = iconHover
			set_css_tag('italic', 'sFS')
		}
	}

	const set_label_font_deco = () => {
		if (labelDeco === 'underline') {
			iconLabelDeco = iconColor
			set_css_tag('none', 'sFD')
		} else {
			iconLabelDeco = iconHover
			set_css_tag('underline', 'sFD')
		}
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_icon_6 = () => {
		iconSelected = true
		selectedIcon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'sBL')
	}

	const set_icon_7 = () => {
		iconSelected = true
		selectedIcon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'sBT')
	}

	const set_icon_8 = () => {
		iconSelected = true
		selectedIcon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'sBR')
	}

	const set_icon_9 = () => {
		iconSelected = true
		selectedIcon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'sBB')
	}

	const set_icon_10 = () => {
		iconSelected = true
		selectedIcon = 'icon10'
		storeSelectedIcon.set('icon10')
		icon10 = icon10 === false ? true : false
		if (icon10) icon10Color = iconHover
		else icon10Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'sBA')
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool2 = false
				showTool3 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool5 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false
				break

			case 'generalTool3':
				generalTool3 = generalTool3 === true ? false : true
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true

				showTool1 = false
				showTool4 = false
				showTool9 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool4 = false
				showTool9 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool3 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool9 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool5 = false
				showTool7 = false
				showTool8 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool5 = false
				showTool8 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool5 = false
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool0 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 13:
				showTool13 = showTool13 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool11 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 14:
				showTool14 = showTool14 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				showTool11 = false
				showTool15 = false
				showTool16 = false
				break

			case 15:
				showTool15 = showTool15 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool11 = false
				showTool16 = false
				break

			case 16:
				showTool16 = showTool16 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool11 = false
				break
		}
	}

	const change_order = (block, direction) => {
		storeBooking.set(false)
		const toChange = setTimeout(() => {
			re_order(block, direction)
			clearTimeout(toChange)
		}, 100)
	}

	const re_order = async (block, direction) => {
		let changeOrder = true
		blocks = await get_blocks(config)
		if (blocks) {
			blocks.forEach((bl) => {
				if (bl.blockName === block && bl.layoutOrder === 0 && direction === 'up') {
					changeOrder = false
				}

				if (bl.blockName === block && bl.layoutOrder === blocks.length - 1 && direction === 'down') {
					changeOrder = false
				}
			})
			if (changeOrder) {
				shaderChangeOrder = true
				const reorder = await reorder_layout(block, direction)
				storeData.set(reorder)
				shaderChangeOrder = false
			}
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(0)}
				on:keydown={() => open_tool(0)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				LAYOUT POSITION
			</div>
			{#if showTool0}
				<div transition:slide={{ duration: 500 }}>
					<div class="icon_container">
						<div
							class="icon arrow_down"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'down')}
							on:keydown={() => change_order(blockID, 'down')}
						/>
						<div
							class="icon arrow_up"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'up')}
							on:keydown={() => change_order(blockID, 'up')}
						/>
					</div>
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				CONTAINER
			</div>

			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool1')}
						on:keydown={() => open_tool('generalTool1')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool1}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_bg_color}
								on:setopacity={set_bg_color}
								on:settransparent={set_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={backgroundColor}
								initialValue={bgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector ID={idMarginTop} range="20" initialValue={marginTop} on:sizechange={set_margin_top} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="20"
								initialValue={marginBottom}
								on:sizechange={set_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idPadding} range="20" initialValue={padding} on:sizechange={set_padding} />
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(2)}
						on:keydown={() => open_tool(2)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>

					{#if showTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, icon1Color, iconHover }}
									on:click={set_icon_1}
									on:keydown={set_icon_1}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, icon2Color, iconHover }}
									on:click={set_icon_2}
									on:keydown={set_icon_2}
								/>
								<div
									id="icon3"
									class="icon icon3"
									use:styles={{ icon, icon3Color, iconHover }}
									on:click={set_icon_3}
									on:keydown={set_icon_3}
								/>
								<div
									id="icon4"
									class="icon icon4"
									use:styles={{ icon, icon4Color, iconHover }}
									on:click={set_icon_4}
									on:keydown={set_icon_4}
								/>
								<div
									id="icon5"
									class="icon icon5"
									use:styles={{ icon, icon5Color, iconHover }}
									on:click={set_icon_5}
									on:keydown={set_icon_5}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_border_color}
										on:setopacity={set_border_color}
										ID={idColor2}
										selectedColor={selectedBorderColor}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idBorderWidth}
										range="50"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idBTradius}
										initialValue={borderTopRadius}
										unit="px"
										range="20"
										on:sizechange={set_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idBBradius}
										initialValue={borderBottomRadius}
										range="20"
										unit="px"
										on:sizechange={set_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(3)}
						on:keydown={() => open_tool(3)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_shadow_color}
								on:setopacity={set_shadow_color}
								ID={idColor3}
								selectedColor={blockBoxShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idShadowX}
								range="10"
								unit="px"
								initialValue={blockBoxShadowX}
								on:sizechange={set_offset_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idShadowY}
								range="20"
								unit="px"
								initialValue={blockBoxShadowY}
								on:sizechange={set_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idShadowBlur}
								range="20"
								unit="px"
								initialValue={blockBoxShadowBlur}
								on:sizechange={set_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TITLE CONTAINER
			</div>

			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool2')}
						on:keydown={() => open_tool('generalTool2')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_title_bg_color}
								on:setopacity={set_title_bg_color}
								on:settransparent={set_title_bg_color}
								transparent="1"
								ID={idColor4}
								selectedColor={blockTitleBackgroundColor}
								initialValue={blockTitleBgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Height</div>
							<SizeSelector
								ID={idTitleHeight}
								range="200"
								unit="px"
								initialValue={blockTitleHeight}
								on:sizechange={set_title_height}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idTitleMT}
								range="20"
								initialValue={blockTitleMarginTop}
								on:sizechange={set_title_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idTitleMB}
								range="20"
								initialValue={blockTitleMarginBottom}
								on:sizechange={set_title_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector
								ID={idTitleP}
								range="20"
								initialValue={blockTitlePadding}
								on:sizechange={set_title_padding}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						box shadow
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_container_SC}
								on:setopacity={set_title_container_SC}
								ID={idColor5}
								selectedColor={titleBarSC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTitleContainerY}
								range="20"
								unit="px"
								initialValue={titleBarY}
								on:sizechange={set_title_container_Y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTitleContainerB}
								range="20"
								unit="px"
								initialValue={titleBarB}
								on:sizechange={set_title_container_B}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>

					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_font_color}
								on:setopacity={set_title_font_color}
								ID={idColor6}
								selectedColor={blockTitleFontColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_block_title_font_family}
								value={blockTitleFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_block_title_font_size}
								value={blockTitleFontSize}
								ID={idSelect2}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconTitleWeight"
									use:styles={{ icon, iconTitleWeight, iconHover }}
									on:click={set_block_title_font_weight}
									on:keydown={set_block_title_font_weight}
								/>
								<div
									id="fstyle"
									class="icon iconTitleStyle"
									use:styles={{ icon, iconTitleStyle, iconHover }}
									on:click={set_block_title_font_style}
									on:keydown={set_block_title_font_style}
								/>
								<div
									id="fdeco"
									class="icon iconTitleDeco"
									use:styles={{ icon, iconTitleDeco, iconHover }}
									on:click={set_block_title_font_underline}
									on:keydown={set_block_title_font_underline}
								/>
								<div
									id="fstroke"
									class="icon iconTitleStroke"
									use:styles={{ icon, iconTitleStroke, iconHover }}
									on:click={set_block_title_font_strikethrough}
									on:keydown={set_block_title_font_strikethrough}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(7)}
						on:keydown={() => open_tool(7)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font shadow
					</div>
					{#if showTool7}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_SC}
								on:setopacity={set_title_SC}
								ID={idColor7}
								selectedColor={blockTitleShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTTXTShadowX}
								range="20"
								unit="px"
								initialValue={blockTitleShadowOffsetX}
								on:sizechange={set_title_SX}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTTXTShadowY}
								range="20"
								unit="px"
								initialValue={blockTitleShadowOffsetY}
								on:sizechange={set_title_SY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTTXTShadowBlur}
								range="20"
								unit="px"
								initialValue={blockTitleShadowBlur}
								on:sizechange={set_title_SB}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(8)}
						on:keydown={() => open_tool(8)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool8}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="cAlignL"
									class="icon txtContAlignL"
									use:styles={{ icon, iconTxtContAlignL, iconHover }}
									on:click={set_title_align_left}
									on:keydown={set_title_align_left}
								/>

								<div
									id="cAlignC"
									class="icon txtContAlignC"
									use:styles={{ icon, iconTxtContAlignC, iconHover }}
									on:click={set_title_align_center}
									on:keydown={set_title_align_center}
								/>

								<div
									id="cAlignR"
									class="icon txtContAlignR"
									use:styles={{ icon, iconTxtContAlignR, iconHover }}
									on:click={set_title_align_right}
									on:keydown={set_title_align_right}
								/>
							</div>
							<div class="icon_container">
								<div
									id="vAlignT"
									class="icon txtValignT"
									use:styles={{ icon, iconValignT, iconHover }}
									on:click={set_title_valign_top}
									on:keydown={set_title_valign_top}
								/>

								<div
									id="vAlignC"
									class="icon txtValignC"
									use:styles={{ icon, iconValignC, iconHover }}
									on:click={set_title_valign_center}
									on:keydown={set_title_valign_center}
								/>

								<div
									id="vAlignB"
									class="icon txtValignB"
									use:styles={{ icon, iconValignB, iconHover }}
									on:click={set_title_valign_bottom}
									on:keydown={set_title_valign_bottom}
								/>
							</div>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(9)}
				on:keydown={() => open_tool(9)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				SELECTION CONTAINER
			</div>
			{#if showTool9}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool3')}
						on:keydown={() => open_tool('generalTool3')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_selection_bg}
								on:setopacity={set_selection_bg}
								on:settransparent={set_selection_bg}
								transparent="1"
								ID={idColor8}
								selectedColor={selectionBG}
								initialValue={selectionOpac}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(14)}
						on:keydown={() => open_tool(14)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>

					{#if showTool14}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon6"
									class="icon icon6"
									use:styles={{ icon, icon6Color, iconHover }}
									on:click={set_icon_6}
									on:keydown={set_icon_6}
								/>
								<div
									id="icon7"
									class="icon icon7"
									use:styles={{ icon, icon7Color, iconHover }}
									on:click={set_icon_7}
									on:keydown={set_icon_7}
								/>
								<div
									id="icon8"
									class="icon icon8"
									use:styles={{ icon, icon8Color, iconHover }}
									on:click={set_icon_8}
									on:keydown={set_icon_8}
								/>
								<div
									id="icon9"
									class="icon icon9"
									use:styles={{ icon, icon9Color, iconHover }}
									on:click={set_icon_9}
									on:keydown={set_icon_9}
								/>
								<div
									id="icon10"
									class="icon icon10"
									use:styles={{ icon, icon10Color, iconHover }}
									on:click={set_icon_10}
									on:keydown={set_icon_10}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_border_SC}
										on:setopacity={set_border_SC}
										ID={idColor10}
										selectedColor={selectedBorderColor}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idSectionBW}
										range="50"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_SW}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(15)}
						on:keydown={() => open_tool(15)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool15}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_selection_SC}
								on:setopacity={set_selection_SC}
								ID={idColor11}
								selectedColor={blockBoxShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idSelectionSX}
								range="20"
								unit="px"
								initialValue={selectionSX}
								on:sizechange={set_selection_SX}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idSelectionSY}
								range="20"
								unit="px"
								initialValue={selectionSY}
								on:sizechange={set_selection_SY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idSelectionSB}
								range="20"
								unit="px"
								initialValue={selectionSB}
								on:sizechange={set_selection_SB}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(10)}
						on:keydown={() => open_tool(10)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						labels
					</div>
					{#if showTool10}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues options={fontFamily} on:select={set_selection_ILFF} value={lableFontFF} ID={idSelect1} />
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_selection_LC}
								on:setopacity={set_selection_LC}
								ID={idColor9}
								selectedColor={lableFontColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="lFweight"
									class="icon iconLabelWeight"
									use:styles={{ icon, iconLabelWeight, iconHover }}
									on:click={set_label_font_weight}
									on:keydown={set_label_font_weight}
								/>
								<div
									id="lFstyle"
									class="icon iconLabelStyle"
									use:styles={{ icon, iconLabelStyle, iconHover }}
									on:click={set_label_font_style}
									on:keydown={set_label_font_style}
								/>
								<div
									id="lFdeco"
									class="icon iconLabelDeco"
									use:styles={{ icon, iconLabelDeco, iconHover }}
									on:click={set_label_font_deco}
									on:keydown={set_label_font_deco}
								/>
							</div>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(11)}
						on:keydown={() => open_tool(11)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						inputs
					</div>
					{#if showTool11}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues options={fontFamily} on:select={set_selection_IFF} value={inputFontFamily} ID={idSelect1} />
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_selection_IFC}
								on:setopacity={set_selection_IFC}
								ID={idColor12}
								selectedColor={inputFontColor}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_selection_IBGC}
								on:setopacity={set_selection_IBGC}
								ID={idColor13}
								selectedColor={inputBg}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Focus Color</div>
							<ColorSelector
								on:setcolor={set_selection_IFOC}
								on:setopacity={set_selection_IFOC}
								ID={idColor14}
								selectedColor={inputFocus}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_selection_IBC}
								on:setopacity={set_selection_IBC}
								ID={idColor15}
								selectedColor={inputBorderColor}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Shadow</div>
							<ColorSelector
								on:setcolor={set_selection_ISC}
								on:setopacity={set_selection_ISC}
								ID={idColor16}
								selectedColor={inputShadowColor}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idInputSX}
								range="20"
								unit="px"
								initialValue={inputShadowX}
								on:sizechange={set_selection_ISX}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idInputSY}
								range="20"
								unit="px"
								initialValue={inputShadowY}
								on:sizechange={set_selection_ISY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idInputSB}
								range="20"
								unit="px"
								initialValue={inputShadowBlur}
								on:sizechange={set_selection_ISB}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(16)}
						on:keydown={() => open_tool(16)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						date colors
					</div>
					{#if showTool16}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Current Day</div>
							<ColorSelector
								on:setcolor={set_selection_PCDC}
								on:setopacity={set_selection_PCDC}
								ID={idColor21}
								selectedColor={pickerColorSelected}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Disabled Days</div>
							<ColorSelector
								on:setcolor={set_selection_PDDC}
								on:setopacity={set_selection_PDDC}
								ID={idColor22}
								selectedColor={pickerColorDisabled}
								showTranparency={false}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Hover Day</div>
							<ColorSelector
								on:setcolor={set_selection_PDHC}
								on:setopacity={set_selection_PDHC}
								ID={idColor23}
								selectedColor={pickerColorHover}
								showTranparency={false}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(13)}
						on:keydown={() => open_tool(13)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						button
					</div>
					{#if showTool13}
						<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
						<SelectValues options={fontFamily} on:select={set_selection_BFF} value={buttonFontFamily} ID={idSelect1} />
						<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
						<ColorSelector
							on:setcolor={set_selection_BFC}
							on:setopacity={set_selection_BFC}
							ID={idColor17}
							selectedColor={buttonFontColor}
							showTranparency={false}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Font Hover</div>
						<ColorSelector
							on:setcolor={set_selection_BFH}
							on:setopacity={set_selection_BFH}
							ID={idColor17}
							selectedColor={buttonFontHover}
							showTranparency={false}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
						<ColorSelector
							on:setcolor={set_selection_BBGC}
							on:setopacity={set_selection_BBGC}
							ID={idColor18}
							selectedColor={buttonBg}
							showTranparency={false}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Hover Color</div>
						<ColorSelector
							on:setcolor={set_selection_BHC}
							on:setopacity={set_selection_BHC}
							ID={idColor19}
							selectedColor={buttonBgHover}
							showTranparency={false}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
						<ColorSelector
							on:setcolor={set_selection_BBC}
							on:setopacity={set_selection_BBC}
							ID={idColor20}
							selectedColor={buttonBorderColor}
							showTranparency={false}
						/>
					{/if}
				</div>
			{/if}
		</section>
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon6 {
		background-color: var(--icon6Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon7 {
		background-color: var(--icon7Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon8 {
		background-color: var(--icon8Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon9 {
		background-color: var(--icon9Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon10 {
		background-color: var(--icon10Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.iconTitleWeight {
		background-color: var(--iconTitleWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTitleStyle {
		background-color: var(--iconTitleStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTitleDeco {
		background-color: var(--iconTitleDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTitleStroke {
		background-color: var(--iconTitleStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.iconLabelWeight {
		background-color: var(--iconLabelWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconLabelStyle {
		background-color: var(--iconLabelStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconLabelDeco {
		background-color: var(--iconLabelDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.txtContAlignL {
		background-color: var(--iconTxtContAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtContAlignC {
		background-color: var(--iconTxtContAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtContAlignR {
		background-color: var(--iconTxtContAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtValignT {
		background-color: var(--iconValignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.txtValignC {
		background-color: var(--iconValignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.txtValignB {
		background-color: var(--iconValignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
